module.exports = __webpack_public_path__ + "static/media/redbus.79e62910.png";